import { computed, observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { autobind } from 'core-decorators';
import routeConfigs from '@src/pages/app-router/route-configs';
import { useMount, useRequest } from 'ahooks';
import Service from './service';
import AntdMessage from '@src/components/antd/message';
import CultureSwiperStore from './components/culture-swiper/store';
import { useEffect } from 'react';

class NaviBarStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }
  cultureSwiperStore = new CultureSwiperStore();

  @observable isLoading = true;

  @observable isExpand = false;

  @observable whiteNaviBarBottomRightStatus = false;

  @observable stickAcative = false;
  /**
   * 游戏列表
   * @type {[]}
   */
  @observable gamesList = [];

  @observable
  recommendGameList = [
    {
      title: '剑网3/剑网3无界',
      iconUrl: require('./images/pc_seasunbar_logo_1.png'),
      websiteLink: '//jx3.xoyo.com'
    },
    {
      title: '剑网3/剑网3无界',
      iconUrl: require('./images/pc_seasunbar_logo_1.png'),
      websiteLink: '//jx3.xoyo.com'
    },
    {
      title: '剑网3/剑网3无界',
      iconUrl: require('./images/pc_seasunbar_logo_1.png'),
      websiteLink: '//jx3.xoyo.com'
    }
  ];

  @computed
  get gamesTypeList() {
    const gamesTypeList = {};

    this.gamesList.forEach(game => {
      const typeKey = game.game_type.split('-')[0];
      const typeOrder = game.game_type.split('-')[1];
      if (!gamesTypeList[typeKey]) {
        gamesTypeList[typeKey] = {
          type: typeKey,
          order: typeOrder,
          games: []
        };
      }

      gamesTypeList[typeKey].games.push({
        list_order: game.listorder,
        title: game.title,
        game_desc: game.game_desc,
        game_icon: game.game_icon, // Placeholder for game icon
        game_type: game.game_type.split('-')[0],
        game_website_link: game.game_website_link.replace('https://', '//')
      });
      gamesTypeList[typeKey].games.sort((a, b) => a.order - b.order);
    });

    return gamesTypeList;
  }

  /**
   * 官方工具
   * @type {[{title: string, url: string},{title: string, url: string},{title: string, url: string}]}
   */
  @observable
  officialTool = [
    { title: '启动器', url: 'https://g.xoyo.com/#/' },
    { title: '万宝楼', url: 'https://www.seasunwbl.com/' },
    { title: '游戏管家', url: 'https://www.xoyo.com/apps' }
  ];
  /**
   * 用户服务
   * @type {[{title: string, url: string},{title: string, url: string},{title: string, url: string},{title: string, url: string}]}
   */
  @observable
  userService = [
    { title: '充值中心', url: 'https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fcharge.xoyo.com%2Fcharge-items' },
    { title: '个人中心', url: 'https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fi.xoyo.com%2F' },
    { title: '客服中心', url: 'https://support.seasungames.cn/' },
    { title: '帮助中心', url: 'https://help.xoyo.com/help?category=4115' }
  ];
  /**
   * 了解我们
   * @type {[{title: string, url: string},{title: string, url: string}]}
   */
  @observable
  aboutUs = [
    { title: '新闻资讯', url: 'https://www.xoyo.com/news-list' },
    {
      title: '企业文化',
      url: 'https://about.seasungames.cn/'
    }
  ];
  @observable
  joinUs = [
    {
      title: '社会招聘',
      url: 'https://job.seasungames.cn/'
    },
    { title: '校园招聘', url: 'https://job.seasungames.cn/campus' },
    { title: '训练营', url: 'https://sc.xishanju.com/#/' }
  ];

  @computed
  get gamesMenuList() {
    const _gameTypeKeys = Object.keys(this.gamesTypeList);
    if (_gameTypeKeys.length === 0) {
      return [];
    } else {
      const _gameTypeArr = [];
      _gameTypeKeys.forEach(item => {
        _gameTypeArr.push({
          key: item,
          type: this.gamesTypeList[item].type,
          order: this.gamesTypeList[item].order
        });
      });
      return _gameTypeArr.sort((a, b) => a.order - b.order);
    }
  }

  @autobind
  onStickAcative(state) {
    this.stickAcative = state;
  }

  @autobind
  onLogoMenuHover() {
    this.isExpand = true;
    this.whiteNaviBarBottomRightStatus = true;
  }

  @autobind
  closeExpandMenu() {
    this.isExpand = false;
  }

  @autobind
  redirectGames() {
    window.open('https://www.seasungames.cn/#/games');
  }

  @autobind
  redirectIndex() {
    this.redirect(routeConfigs.MAIN.getFormatPath());
  }

  @autobind
  async init() {
    try {
      const res = await Promise.all([this.getGameListRequest.run(), this.getRecommendListRequest.run()]);

      // this.gamesList = res[0].list;
      this.recommendGameList = res[1].list.map(item => {
        return {
          title: item.title,
          iconUrl: item.game_icon,
          websiteLink: item.game_website_link
        };
      });
    } catch (err) {
      console.log(err);
      AntdMessage.error(err.message);
    }
  }

  use() {
    super.use();
    this.getGameListRequest = useRequest(async () => await Service.getGameList(), { manual: true, throwOnError: true });
    this.getRecommendListRequest = useRequest(async () => await Service.getRecommendList(), {
      manual: true,
      throwOnError: true
    });
    useMount(() => {
      this.isActive = true;
      this.init();
    });
    useEffect(
      () => {
        if (!this.getGameListRequest.loading && !this.getRecommendListRequest.loading && !this.cultureSwiperStore.isLoading) {
          this.isLoading = false;
        } else {
          this.isLoading = true;
        }
        // 做一个4s的兜底
        setTimeout(() => {
          if (this.isLoading) {
          }
          this.isLoading = false;
        }, 4000);
      },
      [this.getGameListRequest.loading, this.getRecommendListRequest.loading]
    );
  }
}

export default NaviBarStore;
